import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { StudentProfile } from '../../../lib/database.types';
import '../OJTCoordinator.css';
import './ProgramStat.css';

// Card Component
interface ActiveStudentsCardProps {
  count: number;
  onClick: () => void;
}

export const ActiveStudentsCard: React.FC<ActiveStudentsCardProps> = ({ count, onClick }) => {
  return (
    <div className="stat-card clickable" onClick={onClick}>
      <div className="stat-number">{count}</div>
      <div className="stat-label">Active Students</div>
    </div>
  );
};

// Modal Component
interface ActiveStudentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  studentsWithStatus: Array<StudentProfile & { status: 'Active' | 'Inactive', lastCheckIn?: string }>;
}

export const ActiveStudentsModal: React.FC<ActiveStudentsModalProps> = ({ isOpen, onClose, studentsWithStatus }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content students-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Students Activity Status - Today</h2>
          <button className="close-modal-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div className="modal-body">
          <div className="students-table-container">
            <table className="students-table">
              <thead>
                <tr>
                  <th>Student ID</th>
                  <th>Name</th>
                  <th>Department</th>
                  <th>Status</th>
                  <th>Last Check-In</th>
                </tr>
              </thead>
              <tbody>
                {studentsWithStatus.map((student) => (
                  <tr key={student.id}>
                    <td>{student.student_id}</td>
                    <td>{student.first_name} {student.last_name}</td>
                    <td>{student.department}</td>
                    <td>
                      <span className={`status-badge ${student.status === 'Active' ? 'status-active' : 'status-inactive'}`}>
                        {student.status}
                      </span>
                    </td>
                    <td>
                      {student.lastCheckIn 
                        ? new Date(student.lastCheckIn).toLocaleTimeString('en-US', { 
                            hour: '2-digit', 
                            minute: '2-digit',
                            hour12: true 
                          })
                        : 'No check-in today'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

